import { useLocation } from 'react-router';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { DURATION_SLOW, EASE_IN, EASE_OUT, useReducedMotion, reduceMotion } from '@/lib/motion';
import { useTenantPath } from '@/lib/auth/TenantCodeContext';

export function RoadTransportIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  const location = useLocation();
  const prefersReduced = useReducedMotion();
  const roadTransportPath = useTenantPath('/road-transport');
  const isActive = location.pathname === roadTransportPath || location.pathname.startsWith(roadTransportPath + '/');

  return (
    <span className={cn('overflow-hidden flex items-center justify-center', className)} style={style}>
      <motion.i
        initial={false}
        animate={isActive ? { x: [0, 24, -24, 0] } : { x: 0 }}
        transition={reduceMotion(prefersReduced, {
          duration: DURATION_SLOW * 2,
          ease: [EASE_IN, 'linear', EASE_OUT],
          times: [0, 0.45, 0.45, 1],
        })}
        className={cn('pi pi-truck', '[font-size:var(--sidebar-icon-size)]')}
        aria-hidden="true"
      />
    </span>
  );
}
